import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import animate from "animate.css";
import schema from "async-validator";
import dialog from "./utils/dialog";
import $scroll from "@utils/loading";
import cookie from "@utils/store/cookie";
import { Area } from "vant";
Vue.use(Area);
import { Switch } from "vant";
Vue.use(Switch);
import { Circle } from "vant";
Vue.use(Circle);
import "./plugins/vant.js";
import "vant/lib/index.less";

import iView from "iview"; // 导入组件库
// import VueLuckyCanvas from "@lucky-canvas/vue";
import LeeVue from "leevueplugin";
Vue.use(LeeVue);
import "iview/dist/styles/iview.css"; // 导入样式

Vue.use(iView);

// import swipperTabs from "vue-slider-tabs"; // 导入组件库
// Vue.use(swipperTabs);

import "@assets/iconfont/iconfont";
import "@assets/iconfont/iconfont.css";
import "@assets/js/media_750";
import "vue-ydui/dist/ydui.base.css";
import "@assets/css/base.css";
import "@assets/css/reset.css";
import "@assets/css/style.css";
import { isWeixin, parseQuery } from "@utils";
import vueLazyLoad from "vue-lazyload";

import axios from "axios";

Vue.prototype.$axios = axios;

import VEmojiPicker from "v-emoji-picker";
Vue.use(VEmojiPicker);

Vue.use(vueLazyLoad, {
  preload: 1.3, //加载高度比。
  loading: require("@assets/images/noPictrue.png"), //加载时的过渡图片
  error: require("@assets/images/err.png"), //加载失败的图片
  attempt: 1 //每次加载的张数。
});
Vue.use(animate);
Vue.config.productionTip = false;
Vue.config.devtools = process.env.NODE_ENV !== "production";
Vue.prototype.$validator = function(rule) {
  return new schema(rule);
};
Vue.prototype.$scroll = $scroll;
Vue.prototype.$dialog = dialog;
import dayjs from "dayjs";
Vue.prototype.$dayjs = dayjs;
const CACHE_KEY = "clear_0.0.1";

if (!cookie.has(CACHE_KEY)) {
  cookie.clearAll();
  cookie.set(CACHE_KEY, 1);
}

let cookieName = "VCONSOLE";
let query = parseQuery();
let urlSpread = query["spread"];
let vconsole = query[cookieName.toLowerCase()];
let md5Crmeb = "b14d1e9baeced9bb7525ab19ee35f2d2"; //CRMEB MD5 加密开启vconsole模式
let md5UnCrmeb = "3dca2162c4e101b7656793a1af20295c"; //UN_CREMB MD5 加密关闭vconsole模式

if (urlSpread !== undefined) {
  var spread = cookie.get("spread");
  urlSpread = parseInt(urlSpread);
  if (!Number.isNaN(urlSpread) && spread !== urlSpread) {
    cookie.set("spread", urlSpread || 0);
  } else if (spread === 0 || typeof spread !== "number") {
    cookie.set("spread", urlSpread || 0);
  }
}

const _isWechat = isWeixin();

if (vconsole !== undefined) {
  if (vconsole === md5UnCrmeb && cookie.has(cookieName))
    cookie.remove(cookieName);
} else vconsole = cookie.get(cookieName);

if (vconsole !== undefined && vconsole === md5Crmeb) {
  cookie.set(cookieName, md5Crmeb, 3600);
  const module = () => import("vconsole");
  module().then(Module => {
    new Module.default();
  });
}

if (_isWechat) {
  const module = () => import("@libs/wechat");
  module().then(Module => {
    Module.default().then(() => Module.oAuth());
  });
}
import VueI18n from "vue-i18n";
import request from "@utils/request";
Vue.use(VueI18n); // 挂载
const i18n = new VueI18n({
  locale: "zh-CN", // 语言标识
  messages: {
    "zh-CN": require("./lang/zh"), // 通过require引入中文语言包
    "en-US": require("./lang/en") // 通过require引入英文语言包
  }
});

const $vm = new Vue({
  i18n,
  router,
  store,
  data() {
    return {};
  },
  render: h => h(App)
});
//api/online
setInterval(() => {
  request.get("/index/online");
}, 30 * 1000);
setTimeout(() => {
  $vm.$mount("#app");
}, 0);
